<template>
  <div class="download_box">
    <div class="download_img">
      <img src="@/assets/img/qietu/downloadImg.png" alt="" />
    </div>
    <div class="download_content">
      <div class="app_name">
        <img src="@/assets/img/mobileImg/download6.png" alt="" />
        <div class="app_title">
          <h3>中文知识网</h3>
          <p>聚合知识分享见解创造价值</p>
        </div>
      </div>
      <div class="app_code">
        <div class="code" id="code" ref="code"></div>
        <p>手机扫码下载中文知识网</p>
      </div>
      <div class="app_btn">
        <Button type="primary" class="btn ios" @click="iosDownload"
          >iPhone下载</Button
        >
        <Button
          v-throttleClick="3000"
          type="primary"
          class="btn android"
          @click="androidDownload"
          >Android下载</Button
        >
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      androidUrl: "",
      version: '',
    };
  },
  created() {
    this.getAndroidVersion();
  },
  mounted() {
    // this.getCode();
  },
  methods: {
    getCode() {
      this.qr = new QRCode("code", {
        width: 215,
        height: 215, // 高度
        text: this.$global.url1 + `jumpdownload?version=${this.version}`, // 二维码内容
      });
    },
    async getAndroidVersion() {
      const res = await axios.get(
        `${process.env.NODE_ENV === 'development' ? this.$global.url : ''}/zw-public/version/nf/getNewestVersion`,
        { headers: { deviceType: "android" } }
      );
      if (res.status === 200 && res.data.resultCode === "200") {
        this.androidUrl = res.data.data.upgradePath;
        this.version = res.data.data.versionNumber;
        this.$nextTick(() => {
          this.getCode();
        })
      } else {
        this.$Message.error("数据获取异常");
      }
    },
    iosDownload() {
      window.open("https://apps.apple.com/us/app/中文知识网/id1618139452")
    },
    androidDownload() {
      if (this.androidUrl) {
        window.location.href = this.androidUrl;
      } else {
        this.$Message.error("文件获取失败,请刷新后重试");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.download_box {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  .download_img {
    margin-right: 110px;
    width: 340px;
    height: 580px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .download_content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 30px 0;
    height: 580px;
    .app_name {
      display: flex;
      height: 62px;
      img {
        width: 62px;
        height: 100%;
      }
      .app_title {
        margin-left: 5px;
        line-height: 31px;
        color: #333333;
        h3 {
          font-size: 21px;
        }
        p {
          font-size: 8px;
        }
      }
    }
    .app_code {
      // .code {
      //   height: 168px;
      //   width: 168px;
      // }
      p {
        text-align: center;
        margin-top: 10px;
        font-size: 15px;
        color: #373737;
      }
    }
    .app_btn {
      .btn {
        width: 226px;
        height: 63px;
        border-radius: 10px;
      }
      .ios {
        margin-right: 58px;
      }
    }
  }
}
</style>